import { useEffect, useContext, useState } from "react";
import { Box, Tabs, Tab, Fab, Dialog, DialogTitle, List, ListItem, ListItemText, ListItemIcon, ListItemButton } from "@mui/material";
import Navbar from "./header/Navbar";
import SubNavbar from "./header/SubNavbar";
import MapRoot from "./MapRoot";
import RightPanel from "./panels/RightPanel";
import Explore from "./panels/Explore";
import { CityProfileVisibleContext } from "../contexts/CityProfileVisibleContext";
import { LeftPanelVisibleContext } from "../contexts/LeftPanelVisibleContext";
import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from "@mui/material/useMediaQuery";
import { navbarMenuItems } from "../constants";
import CityContext from "../contexts/CityContext";


export default function Layout() {
  const { leftVisible, setLeftVis } = useContext(LeftPanelVisibleContext);
  const { visible, setVis } = useContext(CityProfileVisibleContext);
  const [mobileVisCalled, setMobileVisCalled] = useState(false);
  const [mobileTabValue, setMobileTabValue] = useState(0)
  const [expandMenu, setExpandMenu] = useState(false)
  const { city } = useContext(CityContext);


  const matches = useMediaQuery("(max-width:1000px)");
  useEffect(() => {
    if (matches && !mobileVisCalled) {
      setLeftVis(true);
      setVis(false);
      setMobileVisCalled(true);
    }
  }, [matches, mobileVisCalled, setVis, setLeftVis]);


  return (
    <Box className="layout__container">
      <Navbar />
      {(!matches || city) && <SubNavbar />}
      <Box
        className="layout__inner"
      >
        {!matches && <RightPanel />}
        <MapRoot />
      </Box>
      {matches && (
        <Box
          display="flex"
          className="layout__panel--mobile"
          flexDirection="column"
          sx={{
            borderBottom: "0.5px solid gray"
          }}
        >
          <Tabs className="layout__tabs--mobile" onChange={(e, v) => setMobileTabValue(v)} value={mobileTabValue}>
            <Tab
              className="layout__tab-button--mobile"
              label="Explore"
              disableRipple
              value={0}
              onClick={() => {
                setLeftVis(true)
                setVis(false)
              }}
            />
            <Tab
              className="layout__tab-button--mobile"
              label="10-Minute Walk Statistics"
              disableRipple
              value={1}
              onClick={() => {
                setVis(true)
                setLeftVis(false)
              }}
            />
          </Tabs>
          {leftVisible && (<Explore />)}
          {visible && (<RightPanel />)}
        </Box>
      )}
      {matches && (
        <Box
          sx={{
            mr: "86px",
            p: "10px",
            fontSize: "10pt",
            fontStyle: "italic",
            // flexGrow: "3 1 20px",
          }}
        >
          For a streamlined interface, some features are not available for mobile users. For full functionality, please view the app on a desktop browser.
        </Box>
      )}
      {matches && (
        <Fab
          className="layout__fab--mobile"
          color="primary"
          aria-label="Feedback and More Info"
          onClick={() => setExpandMenu(!expandMenu)}
        >
          <HelpIcon />
        </Fab>
      )}
      <Dialog
        open={expandMenu}
        onClose={() => setExpandMenu(false)}
      >
        <DialogTitle className="layout__menu-title--mobile">Feedback and More Info</DialogTitle>
        <List dense sx={{ pt: 0 }}>
          <ListItem disableGutters className="layout__menu-item--mobile">
            <ListItemButton className="layout__menu-item-button--mobile" onClick={() => setExpandMenu(false)} key={99}>
              <ListItemText primary={"Close"} />
              <ListItemIcon className="layout__menu-item-icon--mobile">
                <CloseIcon />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          {navbarMenuItems.map((item: any, i: any) => 
            <ListItem disableGutters className="layout__menu-item--mobile">
              <ListItemButton
                className="layout__menu-item-button--mobile"
                component="a"
                key={i}
                disabled={(item.label === "Edit Your Park Data" && !city) || item.label === "Acknowledgement of Limitations"}
                href={item.url}
                target="_blank"
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </Dialog>
    </Box>
  );
}
